import { Location2DSchema } from './location';
import { Schema } from 'effect';

export const DockPointIdSchema = Schema.String;
export type DockPointId = Schema.Schema.Type<typeof DockPointIdSchema>;

export const DockPointSchema = Schema.Struct({
  id: DockPointIdSchema,
  name: Schema.String,
  location: Location2DSchema
});
export type DockPoint = Schema.Schema.Type<typeof DockPointSchema>;
